import { instance } from '@/api/instances'

const toShortDate = date => {
  return new Date(`${date}Z`).toLocaleString('pt-BR', {
    dateStyle: 'short'
  })
}

const addSelectedTestResults = ({ commit, state }, name) => {
  const updated = [...state.selectedTestResults.laboratory, name]
  commit('updateSelectedTestResults', { data: updated, type: 'laboratory' })
}

const removeSelectedTestResults = ({ commit, state }, name) => {
  const updated = state.selectedTestResults.laboratory.filter(
    test => test !== name
  )
  commit('updateSelectedTestResults', { data: updated, type: 'laboratory' })
}

const addSelectedImageResult = ({ commit, state }, image) => {
  const updated = [...state.selectedTestResults['images'], image]
  commit('updateSelectedTestResults', { data: updated, type: 'images' })
}

const removeSelectedImageResult = ({ commit, state }, image) => {
  const updated = state.selectedTestResults.images.filter(
    test => test.id !== image.id
  )
  commit('updateSelectedTestResults', { data: updated, type: 'images' })
}

const updateResultsBeingAnalyzed = ({ commit, state }, data) => {
  const updated = {
    ...state.resultsBeingAnalyzed,
    [data.type]: {
      ...state.resultsBeingAnalyzed[data.type],
      [data.group]: data.id
    }
  }
  commit('setResultsBeingAnalyzed', updated)
}

const clearSelectedTestResults = ({ commit }) => {
  commit('clearResultsBeingAnalyzed')
  commit('clearSelectedTestResults')
  commit('clearSelectedResultsToAnalyze')
  commit('clearTestResultFeedbackMessage')
}

const setSelectedResultsToAnalyze = (
  { commit, dispatch, state },
  laboratoryTestResults
) => {
  const labResults = laboratoryTestResults.filter(item =>
    state.selectedTestResults.laboratory.includes(item.name)
  )

  const uniqueLabResults = labResults.map(result => {
    return {
      ...result,
      items: result.items
        .reduce((acc, curr) => {
          if (curr.hasFeedback || acc.length >= 3) return acc

          const getDate = item => item.slice(0, 10)
          const isFromTheSameDay = item =>
            getDate(item.collectedAt) === getDate(curr.collectedAt)
          const isFromTheSameProvider = item => item.provider === curr.provider

          if (
            !acc.find(
              item => isFromTheSameDay(item) && isFromTheSameProvider(item)
            )
          ) {
            acc = [...acc, curr]
          }

          return acc
        }, [])
        .map(item => ({
          ...item,
          formattedCollectedAt: toShortDate(item.collectedAt)
        }))
    }
  })

  commit('setSelectedResultsToAnalyze', {
    laboratory: uniqueLabResults,
    images: state.selectedTestResults['images'].map(item => ({
      ...item,
      formattedCollectedAt: toShortDate(item.collectedAt)
    }))
  })

  const imagesBeingAnalyzed = state.selectedTestResults['images'].map(item => ({
    type: 'images',
    group: item.name,
    id: item.id
  }))

  imagesBeingAnalyzed.map(img => dispatch('updateResultsBeingAnalyzed', img))
}

const setTestResultFeedbackMessage = (
  { commit },
  testResultFeedbackMessage
) => {
  commit('setTestResultFeedbackMessage', testResultFeedbackMessage)
}

const submitAnalyze = async (store, { personId, healthPlanTaskIds }) => {
  try {
    const data = {
      content: store.state.testResultFeedbackMessage,
      aliceTestResultBundleIds: store.getters.resultsBeingAnalyzedIds,
      healthPlanTaskIds
    }

    await instance.post(`persons/${personId}/test_results/feedback`, {
      json: data
    })
  } catch (error) {
    store.dispatch('errors/setError', {
      error,
      request: 'testResultsAnalyze/submitAnalyze'
    })
  }
}

export default {
  addSelectedImageResult,
  removeSelectedImageResult,
  addSelectedTestResults,
  removeSelectedTestResults,
  updateResultsBeingAnalyzed,
  clearSelectedTestResults,
  setSelectedResultsToAnalyze,
  setTestResultFeedbackMessage,
  submitAnalyze
}
